module.exports = __webpack_public_path__ + "img/photo-02.3e0c647b.jpg";